"use strict";

var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileDropZone = void 0;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Button = require("../../../elements/button/Button");
var _react = _interopRequireWildcard(require("react"));
var _reactDropzone = require("react-dropzone");
var _useTranslation2 = require("../../../hooks/useTranslation/useTranslation");
var _noop = require("../../../utils/noop");
var _fileUpload = require("../../../assets/icons/file-upload.svg");
var _file = require("../../../assets/icons/file.svg");
var _fileDropZoneModule = _interopRequireDefault(require("./file-drop-zone.module.scss"));
var _format = require("../../../utils/files/format");
var FileDropZone = function FileDropZone(_ref) {
  var allowedFileTypes = _ref.allowedFileTypes,
    _ref$maxSizeMb = _ref.maxSizeMb,
    maxSizeMb = _ref$maxSizeMb === void 0 ? 1 : _ref$maxSizeMb,
    _ref$onFileSelectErro = _ref.onFileSelectError,
    onFileSelectError = _ref$onFileSelectErro === void 0 ? _noop.noop : _ref$onFileSelectErro,
    onChange = _ref.onChange,
    instruction = _ref.instruction,
    value = _ref.value,
    id = _ref.id,
    disabled = _ref.disabled;
  var _useTranslation = (0, _useTranslation2.useTranslation)(),
    t = _useTranslation.t;
  var onFileUploaded = (0, _react.useCallback)(function (files) {
    var file = files[0];
    if (file) {
      if (file.size > maxSizeMb * 1024 * 1024) {
        return onFileSelectError({
          error: t('fileUploader.fileSizeError', {
            maxSizeMb: maxSizeMb
          })
        });
      }
      onChange(file);
    }
  }, [maxSizeMb, onChange, onFileSelectError, t]);
  var onRemove = (0, _react.useCallback)(function () {
    onChange(undefined);
  }, [onChange]);
  var _useDropzone = (0, _reactDropzone.useDropzone)({
      onDrop: onFileUploaded,
      accept: allowedFileTypes.join(', '),
      noClick: true,
      noKeyboard: true,
      disabled: disabled
    }),
    getRootProps = _useDropzone.getRootProps,
    getInputProps = _useDropzone.getInputProps,
    isDragActive = _useDropzone.isDragActive,
    open = _useDropzone.open;
  if (value) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _fileDropZoneModule.default['file-drop-zone']
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _fileDropZoneModule.default['file-drop-zone__info']
    }, /*#__PURE__*/_react.default.createElement(_file.ReactComponent, {
      className: _fileDropZoneModule.default['file-drop-zone__file-icon']
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: _fileDropZoneModule.default['file-drop-zone__file-name']
    }, value.name), /*#__PURE__*/_react.default.createElement("span", {
      className: _fileDropZoneModule.default['file-drop-zone__file-size']
    }, "(", (0, _format.formatFileSize)(value.size), ")"), /*#__PURE__*/_react.default.createElement("span", {
      role: "button",
      onClick: disabled ? undefined : onRemove,
      className: (0, _classnames.default)(_fileDropZoneModule.default['file-drop-zone__remove'], (0, _defineProperty2.default)({}, _fileDropZoneModule.default['file-drop-zone__remove--disabled'], disabled))
    }, t('fileDropZone.remove'))));
  }
  return /*#__PURE__*/_react.default.createElement("div", Object.assign({}, getRootProps(), {
    className: (0, _classnames.default)(_fileDropZoneModule.default['file-drop-zone'], (0, _defineProperty2.default)({}, _fileDropZoneModule.default['file-drop-zone--active'], isDragActive))
  }), /*#__PURE__*/_react.default.createElement(_fileUpload.ReactComponent, {
    className: _fileDropZoneModule.default['file-drop-zone__icon']
  }), /*#__PURE__*/_react.default.createElement("input", Object.assign({}, getInputProps(), {
    id: id,
    "data-testid": id
  })), /*#__PURE__*/_react.default.createElement("p", {
    className: (0, _classnames.default)(_fileDropZoneModule.default['file-drop-zone__help-text'], (0, _defineProperty2.default)({}, _fileDropZoneModule.default['file-drop-zone__help-text--disabled'], disabled))
  }, instruction, ",", ' ', /*#__PURE__*/_react.default.createElement(_Button.LinkButton, {
    onClick: open,
    inline: true,
    disabled: disabled,
    className: _fileDropZoneModule.default['file-drop-zone__browse-link']
  }, t('fileDropZone.browse'))));
};
exports.FileDropZone = FileDropZone;